import { TypeaheadBox, withIntl, intlShape } from "lcm-iot-commons";
import { getTimeZones } from "../../utils/timeZones";

type Props = {
  intl: intlShape;
};

function TimeZoneTypeahead(props: Props) {
  const options = getTimeZones();
  const { intl } = props;
  return (
    <TypeaheadBox
      {...props}
      // @ts-expect-error TS(2322) FIXME: Type '{ id: string; options: { identifier: string;... Remove this comment to see the full error message
      id="time-zone-typeahead"
      options={options}
      labelKey="label"
      valueKey="identifier"
      placeholder={intl.formatMessage({ id: "label.time_zone" })}
    />
  );
}

export default withIntl(TimeZoneTypeahead);
